import { DataContext } from '../../data/DataContext';
import { useContext } from 'react';
import { RadioButton, Input } from '../controls'
import { GetQuestion} from '../../data/MochaData';


const Step2 = () => {

    const { CVS, setCVS, changeHandler } = useContext(DataContext);
    //GetQuestion('cm_p2_p1')

    const changeChk = (question: string, value:boolean) => {
        setCVS({...CVS,[question]: value});
    }

    return (
        <div className="step-cvs">
            <div className="step-container-cvs">
                <div className="lbl-paso-t1 mt10">
                    <span className="">Cuestionario médico</span>
                </div>
                <div className="mt-10">
                    <span className="lbl-paso-t2">(*) Espacios requeridos</span>
                </div>
                <div className="mt-5 mb-30">
                    <span className="lbl-paso-t3">Es necesario que respondas a las siguientes preguntas para gestionar tu cotización</span>
                </div>
                <RadioButton label={GetQuestion('cm_p2_p1')} field={'cm_p2_p1'} onChange={changeChk} isCheked={CVS.cm_p2_p1} />
                {CVS.cm_p2_p1 && <Input id='cm_p2_p1_1' label={GetQuestion('cm_p2_p1_1')} type='textarea' value={CVS.cm_p2_p1_1} field='cm_p2_p1_1' onChange={changeHandler} />}
                <RadioButton label={GetQuestion('cm_p2_p2')} field={'cm_p2_p2'} onChange={changeChk} isCheked={CVS.cm_p2_p2} />
                {CVS.cm_p2_p2 && <Input id='cm_p2_p2_1' label={GetQuestion('cm_p2_p2_1')} type='textarea' value={CVS.cm_p2_p2_1} field='cm_p2_p2_1' onChange={changeHandler} />}
                <RadioButton label={GetQuestion('cm_p2_p3')} field={'cm_p2_p3'} onChange={changeChk} isCheked={CVS.cm_p2_p3} />
                <RadioButton label={GetQuestion('cm_p2_p4')} field={'cm_p2_p4'} onChange={changeChk} isCheked={CVS.cm_p2_p4} />
                <RadioButton label={GetQuestion('cm_p2_p5')} field={'cm_p2_p5'} onChange={changeChk} isCheked={CVS.cm_p2_p5} />
            </div>
        </div>
    );
}

export { Step2 };